<template>
	<AsiCardDetail :icon="icons.trimmingCostThreshold" :title="$t('globalConfig.terms.trimmingCost')"
	               :show-action-button="!readonly" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :label="$t('globalConfig.terms.trimmingCostPrice')"
		                    :icon="icons.paymentType" :value="globalConfig.trimmingCostPrice">
			<template v-slot:default v-if="globalConfig.trimmingCostPrice !== null">
				{{
					$n(globalConfig.trimmingCostPrice.amount, {
						key: 'currencyDisplay',
						currency: globalConfig.trimmingCostPrice.currency.currencyCode,
					})
				}}
			</template>
		</AsiCardDetailEntry>

		<AsiCardDetailEntry :label="$t('globalConfig.terms.trimmingCostThreshold')"
		                    :icon="icons.trimmingCostThreshold" :value="globalConfig.trimmingCostThreshold">
			<template v-slot:default v-if="globalConfig.trimmingCostThreshold !== null">
				{{ globalConfig.trimmingCostThreshold }}
			</template>
		</AsiCardDetailEntry>


		<GlobalConfigUpdateDialogTrimmingCost v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen"
		                                      :global-config="globalConfig"
		                                      @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from 'vue-property-decorator';
	import Icon from "@/plugins/icons";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
	import DialogHandler from "@/components/common/DialogHandler";
	import GlobalConfigUpdateDialogTrimmingCost
		from "@/components/global-config/admin/GlobalConfigUpdateDialogTrimmingCost.vue";

	@Component({
		components: {GlobalConfigUpdateDialogTrimmingCost, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class GlobalConfigCardTrimmingCost extends Vue {

		@Prop({type: Object, required: true})
		public globalConfig!: IGlobalConfigAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		@Emit('change')
		public change(): void {
			return;
		}

	}
</script>

<style lang="scss" scoped>

</style>
